import {
  ChangeDetectorRef,
  Component,
  Output,
  TemplateRef,
  EventEmitter,
  Input,
  ViewChild,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/service/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HttpClient } from '@angular/common/http';
import { SignUpComponent } from '../sign-up/sign-up.component';
import { CartWishListService } from 'src/app/service/cart-wishlist-service';
import { isPlatformBrowser } from '@angular/common';
import { ErrorModalComponent } from '../error-modal/error-modal.component';
import { phoneNumberValidator } from 'src/app/directive/phone-number-validator';


@Component({
  selector: 'trpx-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss'],
})
export class SignInComponent {
  signInModalRef?: BsModalRef;

  otpGenerationForm: any = FormGroup;
  otpVariForm: any = FormGroup;

  userActivity: any;
  timeToShow: any;
  timeIntervalSet: any;
  isOtpGenerated: boolean = false;
  isRegistered: boolean = true;
  showPrefix = false;
  passedPhone: any;
  isLoading: boolean = false;
  isSignIn = true;
  countryData: any;
  showForm = false;
  mobileNumber = null;
  mobileNumberShow: any;
  countryCode = null;
  travelAgent = false;
  @Input() isAffiliate: any;
  @Input() isAgent: any;
  @Input() fromPayment: any;
  @Input() agentNumber: any;
  @Input() isOtpGenerate: any;
  @Input() agentData: any;
  @Input() timerDuration: number = 3;
  @Output() setCustomerForm = new EventEmitter<any>();
  @Output('closeModal') closeModal: EventEmitter<any> = new EventEmitter();
  modalRef?: BsModalRef;
  @ViewChild('signup')
  signup!: TemplateRef<any>;

  selectedDial: string = '+91';
  toCartData: any;

  isNew: boolean = true;
  errorModalRef?: BsModalRef;
  countryCodes: any[] = [];

  constructor(
    private http: HttpClient,
    public router: Router,
    private fb: FormBuilder,
    private toastr: ToastrService,
    public authService: AuthService,
    private modalService: BsModalService,
    private cdr: ChangeDetectorRef,
    public cartWishService: CartWishListService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this.passedPhone = this.router
        ?.getCurrentNavigation()
        ?.extras?.state?.['mobile_number'].toString();
    }

    this.otpVariForm = this.fb.group({
      otpFormArray: this.fb.array([
        this.fb.control(''),
        this.fb.control(''),
        this.fb.control(''),
        this.fb.control(''),
      ]),
    });

    this.otpGenerationForm = this.fb.group({
      country_code: ['+91', Validators.required],
      mobile_number: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.getData().subscribe((response: any) => {
      this.countryData = response;
      this.countryCodes = response;
      this.otpGenerationForm = this.fb.group(
        {
          country_code: ['+91', Validators.required],
          mobile_number: [this.passedPhone || '', Validators.required],
        },
        {
          validators: phoneNumberValidator(this.countryCodes),
        }
      );

      this.cdr.detectChanges();
    });

    this.popShowSubject();
    if (this.isOtpGenerate) {
      this.isOtpGenerated = this.isOtpGenerate;
    }
    if (this.agentNumber) {
      this.otpGenerationForm.value.mobile_number = this.agentNumber;
    }
    if (this.isOtpGenerate) {
      this.timer(this.timerDuration);
    }
  }

  openErrorModal(
    errorData?: any,
    autoClose?: any,
    autoCloseTime?: number,
    modalColor?: string
  ) {
    const initialState = {
      errorData: errorData,
      autoClose: autoClose, // Enable auto-close
      autoCloseTime: autoCloseTime, // Close after 3 seconds
      modalColor: modalColor,
    };

    this.errorModalRef = this.modalService.show(ErrorModalComponent, {
      class: 'modal-dialog-centered error-modal-style',
      animated: true,
      ignoreBackdropClick: true,
      initialState,
    });
  }

  popShowSubject() {
    this.authService.isLoginShown$.subscribe((res) => {
      if (res) {
        this.isSignIn = res;
      }
    });
  }

  disableArrowKeys(event: any, i: number) {
    if (isPlatformBrowser(this.platformId)) {
      const key = event.key;
      let prev = event.target.previousElementSibling as HTMLInputElement | null;
      let next = event.target.nextElementSibling as HTMLInputElement | null;

      if (key === 'Backspace' || key === 'Delete') {
        if (prev != null && !(event.target as HTMLInputElement).value) {
          prev.focus();
          prev.value = '';
        } else if (key === 'Delete' && next != null) {
          (event.target as HTMLInputElement).value = '';
          next.focus();
        }
      }
    }
  }

  getData() {
    return this.http.get('./assets/json/countrycodes.json');
  }

  receiveCountryCode(code: string) {
    this.otpGenerationForm.controls['country_code'].setValue(code);
    this.otpGenerationForm.updateValueAndValidity();
  }

  openModal(signInModal: TemplateRef<any>) {
    this.signInModalRef = this.modalService.show(signInModal, {
      class: 'modal-dialog-centered',
      animated: true,
    });
  }

  close() {
    this.closeModal.emit('');
  }

  get otpInputs(): FormArray {
    return this.otpVariForm.get('otpFormArray') as FormArray;
  }

  // nextElem(event: any, i: number) {
  //   if (isPlatformBrowser(this.platformId)) {
  //     let next = event.target.nextElementSibling;
  //     let val = event.target.value;

  //     if (next != null && val.length == 1) {
  //       if (val) next.focus();
  //     } else {
  //       const proceedButton = document.querySelector('#proceed-button');
  //       (proceedButton as HTMLElement).focus();
  //     }
  //   }
  // }

  nextElem(event: any, i: number) {
    if (isPlatformBrowser(this.platformId)) {
      let input = event.target;
      let next = input.nextElementSibling as HTMLInputElement;
      let prev = input.previousElementSibling as HTMLInputElement;
      let val = input.value;
  
      // Ensure only one digit is entered
      if (!/^\d$/.test(val)) {
        input.value = '';  // Clear invalid input
        return;
      }
  
      // Move to the next input if a valid digit is entered
      if (val && next) {
        next.focus();
      } 
    }
  }

  timer(minute: any) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.timeToShow = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
      }
    }, 1000);

    return timer;
  }

  isCustomerExist: boolean = true;

  generateOtp() {
    this.isLoading = true;
    if (this.otpGenerationForm.invalid) {
      this.otpGenerationForm.markAllAsTouched();
    }

    if (this.isRegistered) {
      let dataTosend = this.otpGenerationForm.value;
      dataTosend.mobile_number = dataTosend.mobile_number
        .toString()
        .replace(/\s/g, '');
      this.mobileNumberShow = dataTosend.mobile_number;

      this.authService.loginOtpGeneration(dataTosend).subscribe(
        (res: any) => {
          if (res?.is_travel_agent_exists) {
            this.isAgent = true;
            if (!res?.is_travel_agent_approved) {
              this.toastr.warning(
                'Your travel agent account is not approved by admin!'
              );
              this.close();
              return;
            }
          }
          if (!this.isAgent) {
            if (!res.is_customer_exists) {
              this.isCustomerExist = false;
            }
          } else if (this.isAgent) {
            this.isCustomerExist = res.is_travel_agent_exists;
          }

          if (this.timeToShow == null || this.timeToShow == undefined) {
            this.timeIntervalSet = this.timer(3);
          } else {
            clearInterval(this.timeIntervalSet);

            this.timeIntervalSet = this.timer(3);
          }
          this.isOtpGenerated = true;
          this.isLoading = false;
          setTimeout(() => {
            const proceedButton = document.querySelector('#otpNum0');
            (proceedButton as HTMLElement).focus();
          }, 500);
        },
        () => {
          this.isLoading = false;
        }
      );
    } else {
      this.toastr.warning('Please register to continue!');
    }
  }

  resendOtp() {
    clearInterval(this.timeIntervalSet);
    this.otpVariForm.reset();
    this.generateOtp();
  }

  logIntoHome() {
    this.router.navigate(['/home']);
  }

  otpVerify() {
    this.isLoading = true;

    let country_code = this.otpGenerationForm.value.country_code;
    let mobile_number = this.otpGenerationForm.value.mobile_number;

    let otp: any = this.otpInputs.value.join('');
    let dataTosend = {
      country_code: country_code,
      mobile_number: mobile_number,
      otp: otp,
      is_affiliate: this.isAffiliate ?? false,
      is_agent: this.isAgent ?? false,
    };
    console.log("dataTosend.is_affiliate", dataTosend.is_affiliate);
    this.isAffiliate = dataTosend.is_affiliate;
    
    if (otp.length) {
      this.authService.loginOtpForVerify(dataTosend).subscribe(
        (res: any) => {
          this.isLoading = false;

          const setCustomer = (exists: boolean) => {
            this.authService.setIfCustomerExists(exists);
            if (exists) {
              if (isPlatformBrowser(this.platformId)) {
                this.authService.setToken(res?.token?.access);
                this.authService.setRefreshToken(res?.token?.refresh);
                this.authService.setCustomer(res?.customer_profile);
                this.authService.updateCustomer(res?.customer_profile);
                // let currentURL = this.router.url;
                // this.router
                //   .navigateByUrl('/', { skipLocationChange: true })
                //   .then(() => this.router.navigateByUrl(currentURL));
                const redirectData = this.authService.getRedirectData();

                if (!redirectData) {
                  const currentURL = this.router.url;
                  this.router
                    .navigateByUrl('/', { skipLocationChange: true })
                    .then(() => this.router.navigateByUrl(currentURL));
                } else {
                  const { url, queryParams, callback } = redirectData;
                  this.router.navigate([url], { queryParams }).then(() => {
                    if (callback) {
                      callback();
                    }
                  });
                  this.authService.clearRedirectData();
                }
                // if (res.is_travel_agent_exists) {
                //   window.location.reload();
                // }
                // if (!this.isAgent) {
                // this.toastr.success('Logged In Successfully!');
                if (res?.affiliate_message && res?.is_affiliate_exists) {
                   // this.openErrorModal(
                  //   res?.affiliate_message,
                  //   true,
                  //   3000,
                  //   'success'
                  // );
                  this.toastr.success(res?.affiliate_message);
                } else {
                  // this.openErrorModal(
                  //   'Logged In Successfully!',
                  //   true,
                  //   3000,
                  //   'success'
                  // );
                  this.toastr.success('Logged In Successfully!');
                }

                // }

                if (sessionStorage.getItem('toCart')) {
                  let cartData: string | null =
                    sessionStorage.getItem('toCart');
                  this.toCartData = cartData;
                  try {
                    const parsedCartData = JSON.parse(this.toCartData);

                    // Pass the parsed data to the API
                    this.cartWishService
                      .postCartDetails(parsedCartData)
                      .subscribe(
                        (res) => {
                          this.toastr.success('Product Added To Cart!');
                          // Remove the item from sessionStorage after successful operation
                          sessionStorage.removeItem('toCart');
                        },
                        (error) => {
                          console.error('Error adding product to cart:', error);
                        }
                      );
                  } catch (error) {
                    console.error(
                      'Error parsing JSON data from sessionStorage:',
                      error
                    );
                  }
                }
              }
            } else {
              this.authService.setToken(res?.token?.access);
              this.authService.setRefreshToken(res?.token?.refresh);
              this.authService.setCustomer(res?.customer_profile);
            }
          };
          if (!this.isAgent) {
            setCustomer(res.is_customer_exists);
          } else {
            this.travelAgent = true;
            setCustomer(res.is_travel_agent_exists);
            this.authService.setTravelAgentToken(res?.travel_agent_secret);
            if (res.is_travel_agent_exists == true) {
              this.toastr.success('Mobile number is already registered');
              window.location.reload();
            } else {
              this.authService.setToken(res?.token?.access);
              this.authService.setRefreshToken(res?.token?.refresh);
              this.createAgent(this.agentData);
            }

            let currentURL = this.router.url;
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => this.router.navigateByUrl(currentURL));
          }
          // if(currentURL.includes('product/') && res?.is_customer_exists){
          //   this.router
          //   .navigateByUrl('/', { skipLocationChange: true })
          //   .then(() => this.router.navigate(['/payment']));
          // }else{

          // }
          if (!this.fromPayment) {
            // let currentURL = this.router.url.substr(1);
            // let url_lists = ['product/', '/payment', 'transfer-payment'];
            // if (!url_lists.some(url => currentURL.includes(url))) {
            // this.router
            // .navigateByUrl('/', { skipLocationChange: true })
            // .then(() => this.router.navigate([currentURL]));
            // }
            // let currentURL = this.router.url;
            // Navigate to the same URL with query parameters
            // this.router.navigateByUrl('/', { skipLocationChange: true })
            //   .then(() => this.router.navigateByUrl(currentURL));
          } else {
            this.setCustomerForm.emit(this.isCustomerExist);
          }

          if (this.isCustomerExist && this.isAffiliate && res?.is_affiliate_exists) {
            this.close();
          } else if (this.isCustomerExist && this.isAffiliate && !res?.is_affiliate_exists) {
            this.isAffiliate = this.isAffiliate;
            this.showForm = true;
            this.mobileNumber = mobile_number;
            this.countryCode = country_code;
            this.isSignIn = false;
          } else if (this.isCustomerExist && !this.isAffiliate && !res?.is_affiliate_exists) {
            this.close();
          } else {
            this.showForm = true;
            this.mobileNumber = mobile_number;
            this.countryCode = country_code;
            this.isSignIn = false;
            if (this.fromPayment) {
              this.authService.setCustomerMobile({
                country_code: this.countryCode,
                mobile_number: this.mobileNumber,
              });
              this.authService.updateMobile({
                country_code: this.countryCode,
                mobile_number: this.mobileNumber,
              });
            }
          }
        },
        (err: any) => {
          this.isLoading = false;
          this.otpVariForm.reset();
          this.toastr.error(
            err?.error?.message ?? err?.message ?? 'Not a Valid OTP!'
          );
          // this.openErrorModal(
          //   err?.error?.message ?? err?.message ?? 'Not a Valid OTP!',
          //   true,
          //   3000,
          //   'error'
          // );
        }
      );
    } else {
      this.toastr.warning('Enter Valid OTP!');
      // this.openErrorModal('Enter Valid OTP!', true, 3000, 'warning');
    }
  }

  createAgent(formData: any) {
    this.authService.createAgent(formData).subscribe(
      (agentResponse: any) => {
        this.authService.setCustomer(agentResponse?.customer_profile);
        this.authService.updateCustomer(agentResponse?.customer_profile);
        this.toastr.success(
          'Registration Successful! Start your travel agent Journey'
        );
        // Navigate to refresh page
        // const currentURL = this.router.url;
        // this.router
        //   .navigateByUrl('/', { skipLocationChange: true })
        //   .then(() => this.router.navigateByUrl(currentURL));
        window.location.reload();
      },
      (err) => {}
    );
  }
  goToPage() {
    this.close();
    this.router.navigate(['/home']);
  }

  signUp() {
    if (this.otpGenerationForm.value.mobile_number) {
      const signUpModalRef = this.modalService.show(SignUpComponent);
    } else {
      const signUpModalRef = this.modalService.show(SignUpComponent);
    }
  }

  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    this.otpVariForm = this.fb.group({
      otpFormArray: this.fb.array([
        this.fb.control(pastedText[0]),
        this.fb.control(pastedText[1]),
        this.fb.control(pastedText[2]),
        this.fb.control(pastedText[3]),
      ]),
    });
    event.preventDefault();
  }

  openSignupModal(template: any) {
    const modalConfig = {
      ignoreBackdropClick: true,
    };

    const combinedConfig = {
      ...modalConfig,
      class: 'modal-dialog-centered',
      animated: true,
    };

    this.modalRef = this.modalService.show(template, combinedConfig);
  }

  closeSignUpModal() {
    this.modalRef?.hide();
  }
}
